import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PositionsList } from '../components/positions/PositionsList';

export function PositionsPage() {

  return (
    <div>

        {/* Positions Component */}
        <div className="rh-card p-6 rh-hover-shadow rh-animate-fade-in">
          <PositionsList />
        </div>
    </div>
  );
}